import { useEffect, useState } from "react";
import type { CSSProperties } from "react";
import { getLineage } from "../data/lineages";
import { assetPath } from "../lib/urls";
import type { DragonDossier } from "../types";

type Phase = "in" | "out" | "done";

export function IntroSequence({ dossier }: { dossier: DragonDossier }) {
  const [phase, setPhase] = useState<Phase>(() => {
    try {
      if (sessionStorage.getItem("tiamat-intro-seen")) return "done";
    } catch {
      /* ignore */
    }
    return "in";
  });

  useEffect(() => {
    if (phase === "done") return;
    try {
      sessionStorage.setItem("tiamat-intro-seen", "1");
    } catch {
      /* ignore */
    }
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const hold = reduce ? 500 : 3000;
    const toOut = window.setTimeout(() => setPhase("out"), hold);
    const toDone = window.setTimeout(() => setPhase("done"), hold + 950);
    return () => {
      window.clearTimeout(toOut);
      window.clearTimeout(toDone);
    };
  }, [phase]);

  if (phase === "done") return null;

  const lineage = getLineage(dossier.dragon.lineage);
  const art = dossier.appearance.portrait ? assetPath(dossier.appearance.portrait) : "";

  return (
    <div
      className={`intro intro--${phase}`}
      style={{ "--dragon-accent": lineage.accent, "--dragon-soft": lineage.accentSoft } as CSSProperties}
      onClick={() => setPhase("out")}
      role="presentation"
    >
      <div className="intro__art" style={art ? { backgroundImage: `url("${art}")` } : undefined} />
      <div className="intro__grade" />
      <div className="intro__grain" />
      <div className="intro__content">
        <div className="intro__kicker">
          {dossier.dragon.ageClass} {dossier.dragon.lineageLabel}
        </div>
        <h1 className="intro__title">{dossier.dragon.name}</h1>
        <div className="intro__epithet">{dossier.dragon.title}</div>
      </div>
      <button type="button" className="intro__skip" onClick={() => setPhase("out")}>
        Enter the dossier ›
      </button>
    </div>
  );
}
